import { useEffect } from 'react';
import { useRadixPortalStore } from '@shared/stores/radixPortalStore';

export function RadixPortalCloser() {
  const closeAllPortals = useRadixPortalStore((s) => s.closeAllPortals);
  const setCloseAllPortals = useRadixPortalStore((s) => s.setCloseAllPortals);

  useEffect(() => {
    if (!closeAllPortals) return;

    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true }));
    setCloseAllPortals(false);
  }, [closeAllPortals, setCloseAllPortals]);

  return null;
}
